import {Route, Routes} from "react-router-dom";
import HomeScreen from "./pages/HomeScreen/HomeScreen";
import LoginScreen from "./pages/LoginScreen/LoginScreen";
import ProtectedRoute from "./navigation/ProtectedRoute";
import {useAuth} from "./contexts/AuthContext";
import CreateExerciseScreen from "./pages/CreateExercise/CreateExerciseScreen";

function App() {
    const {user, logout} = useAuth();

    return (
        <>
            {user && <button style={{position: 'absolute', right: 24, top: 24}} onClick={logout}>Logout</button>}
            <Routes>
                <Route path="/" element={
                    <ProtectedRoute>
                        <HomeScreen/>
                    </ProtectedRoute>
                }/>
                <Route path="/login" element={<LoginScreen/>}/>
                <Route path="/add-exercise" element={<CreateExerciseScreen/>}/>
            </Routes>
        </>
    );
}

export default App;
